routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('questions', {
      url: '/questions/:type',
      template: require('./index.html'),
      controller: 'QuestionsController',
      controllerAs: 'questions',
      authRequired: true
    });
}



// WEBPACK FOOTER //
// ./src/app/features/questions/routes.js